// @flow
import { find } from 'lodash';

import type { Doctor, Facility, Photo } from '@screens/Details/Doctor/types';

export const connectIncludedData = (doctor: Doctor, included: Array<Facility | Photo>): Doctor => {
  const relationships: Array<['facility', any]> = (Object.entries(doctor.relationships): any);

  if (!relationships.length) return doctor;

  const relationshipsWithIncludedData: $PropertyType<
    Doctor,
    'relationships'> = relationships.reduce(
      (
        relationshipsObject: any,
        relationshipTuple: ['facility', { data: { id: string } }]
      ): $PropertyType<Doctor, 'relationships'> => {
        const relationshipName: string = relationshipTuple[0];
        const relationshipData: { id: string } = relationshipTuple[1].data;
        if (relationshipName === 'consultation_fees') {
          const relatedConsultation_fees: Array<Photo> = Array.isArray(relationshipTuple[1].data)
            ? relationshipTuple[1].data.map(
              ({ id }) => find(included, { id })
            ) : [];
          return {
            ...relationshipsObject,
            [relationshipName]: { data: relatedConsultation_fees }
          };
        }

        const foundRelationshipEntry: ?Facility = find(included, {
          id: relationshipData.id
        });

        if (!foundRelationshipEntry) return relationshipsObject;

        return {
          ...relationshipsObject,
          [relationshipName]: { data: connectPhotos(foundRelationshipEntry, included) }
        };
      },
      {}
    );

  return { ...doctor, relationships: relationshipsWithIncludedData };
};

const connectPhotos = (facility: Facility, included: Array<Facility | Photo>): Facility => {
  const relatedPhotos: Array<Photo> = facility.relationships.photos.data.map(
    ({ id }: Photo): Photo => find(included, { id })
  );

  return ({ ...facility, relationships: { photos: { data: relatedPhotos } } }: any);
};
